module.exports = __webpack_public_path__ + "img/mtc_white.7ac9c6e7.png";